export const sidebarFlags = (state = []) => state;
